import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MenuService, MenuItem } from '../../../core/services/menu.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
  ],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss'
})
export class SideNavComponent {
  private menuService = inject(MenuService);

  // Convert observable to signal
  menuItems = toSignal(this.menuService.menuItems$, { initialValue: [] });

  /**
   * Check if menu item has children
   */
  hasChildren(item: MenuItem): boolean {
    return !!item.children && item.children.length > 0;
  }

  /**
   * Check if menu item is expanded
   */
  isExpanded(item: MenuItem): boolean {
    return this.menuService.isExpanded(item.id);
  }

  /**
   * Toggle menu item expansion
   */
  toggleExpanded(item: MenuItem, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.menuService.toggleExpanded(item.id);
  }
}
